module.exports = __webpack_public_path__ + "static/img/newsPic1.057e02e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/newsPic1.png
// module id = 7DhU
// module chunks = 1